import { render, staticRenderFns } from "./InvitationManage.vue?vue&type=template&id=fe706b5c&scoped=true&"
import script from "./InvitationManage.vue?vue&type=script&lang=js&"
export * from "./InvitationManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe706b5c",
  null
  
)

export default component.exports